module.exports = __webpack_public_path__ + "static/media/icon-piece-loa-01.1d67b746.png";